import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackSubAgentsListOpen } from './trackSubAgentsListOpen';
import { subAgentsSelector } from '../../selectors';
import { useApplicationContext } from '../../utils/applicationContext';
import { getSubAgentsFetchLimit } from '../../utils/getSubAgentsFetchLimit';

type TUseSubAgentsListOpen = {
  source: 'tab' | 'cross';
};

export const useSubAgentsListOpenTracking = ({ source }: TUseSubAgentsListOpen): (() => void) => {
  const { subAgentsList, page } = useSelector(subAgentsSelector);

  const { config } = useApplicationContext();
  const limit = getSubAgentsFetchLimit(config);
  const pageNumber = Math.ceil(page.offset / limit) || 1;

  return React.useCallback(() => {
    const products = subAgentsList.map((subAgent, index) => ({
      id: subAgent.userId,
      offerType: 'agent',
      position: index + 1,
    }));

    trackSubAgentsListOpen({ source, pageNumber, products });
  }, [pageNumber, source, subAgentsList]);
};
